const matrixClubBike = [434860, 434868];
const matrixClubTreadmill = [434861, 434862, 434863, 434864];
const matrixClubElliptical = [434865, 434866, 434867, 434869, 435435, 435436, 435438];
const matrixClubClimbmill = [435437];
const freemotionClubBike = [416735, 422330, 430513, 424904];
const freemotionClubTreadmill = [418153, 420839, 412318, 420841, 428942, 428931, 428944, 428933, 418595];
const freemotionClubElliptical = [422512, 424981];
const matrixRetailTreadmill = [430959, 431191];
const matrixRetailBike = [430960, 431192, 431193];
const matrixRetailElliptical = [430961, 431194, 431195, 431196];
const matrixRetailClimbmill = [429196];
const vault = [421170];
const vue = [428448];

export const CLUB_SOFTWARE_NUMBERS = [
  ...matrixClubBike,
  ...matrixClubTreadmill,
  ...matrixClubElliptical,
  ...matrixClubClimbmill,
  ...freemotionClubBike,
  ...freemotionClubTreadmill,
  ...freemotionClubElliptical,
];

export const MATRIX_CLUB_SOFTWARE_NUMBERS = [
  ...matrixClubBike,
  ...matrixClubTreadmill,
  ...matrixClubElliptical,
  ...matrixClubClimbmill,
];

export const MATRIX_RETAIL_SOFTWARE_NUMBERS = [
  ...matrixRetailTreadmill,
  ...matrixRetailBike,
  ...matrixRetailElliptical,
  ...matrixRetailClimbmill,
];

export const MATRIX_SOFTWARE_NUMBERS = [...MATRIX_CLUB_SOFTWARE_NUMBERS, ...MATRIX_RETAIL_SOFTWARE_NUMBERS];

export const VAULT_SOFTWARE_NUMBERS = [...vault];

export const VUE_SOFTWARE_NUMBERS = [...vue];

export const VAULT_VUE_SOFTWARE_NUMBERS = [...VAULT_SOFTWARE_NUMBERS, ...VUE_SOFTWARE_NUMBERS];
